import { Animator } from './animator';

export class SkeletonAnimator extends Animator {
    constructor(skeleton: any, animationData: any) {
      super(skeleton.bones, animationData);
    }

}

/**
 * An Animator class for animating Skeleton's based on an AnimationData.
 *
 * @constructor
 * @param {THREE.Skeleton} object
 * The skeleton to animate.
 * @param {AnimationData} animationData
 * The AnimationData to animate the geometry with.
 */



